export const interviewsAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'shopping_centers.title': i?.shopping_center?.title,
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};
